import { render, staticRenderFns } from "./task.vue?vue&type=template&id=57f4a0c9&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"
import style0 from "./task.vue?vue&type=style&index=0&id=57f4a0c9&scoped=true&lang=css"
import style1 from "./task.vue?vue&type=style&index=1&id=57f4a0c9&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f4a0c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57f4a0c9')) {
      api.createRecord('57f4a0c9', component.options)
    } else {
      api.reload('57f4a0c9', component.options)
    }
    module.hot.accept("./task.vue?vue&type=template&id=57f4a0c9&scoped=true", function () {
      api.rerender('57f4a0c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/task.vue"
export default component.exports